// El candado de los enlaces públicos que enseñan datos del cliente: el enlace
// de renovación (Lissette 2026-09-25) y el portal del cliente (2026-10-19).
// Pide SOLO los 4 ultimos del seguro social (Lissette 2026-10-01). Si la ficha
// no tiene SSN el servidor no abre (`verify` = 'none') y aqui se le dice que
// llame a su agente. No enseña nada del cliente: solo la marca de la agencia y
// a quien llamar. La regla vive en el servidor:
// deskte-api/src/utils/verificacionDeRenovacion.ts.
import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";

const BRAND = "#00d4ff";

export function Centered({ children }) {
  return (
    <div style={{
      minHeight: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", padding: "1.5rem",
      background: "#f4f7fb", fontFamily: "system-ui,-apple-system,Segoe UI,sans-serif",
    }}>
      {children}
    </div>
  );
}

export function CandadoDelSsn({ bloqueo, t, verificando, onProbar }) {
  const [valor, setValor] = useState("");
  const sinSsn = bloqueo.verify === "none" || bloqueo.error === "no_verification_method";
  const cerradoDelTodo = bloqueo.error === "link_locked";
  const agotado = bloqueo.error === "too_many_attempts" || cerradoDelTodo;
  const listo = /^\d{4}$/.test(valor);
  const enviar = (e) => { e.preventDefault(); if (listo && !agotado) onProbar(valor); };
  const agente = bloqueo.agent?.displayName || bloqueo.agency?.name || "";
  const contacto = agente && <><br />{agente}{bloqueo.agent?.phone ? ` · ${bloqueo.agent.phone}` : ""}</>;
  return (
    <Centered>
      {bloqueo.agency?.logoUrl
        ? <img src={bloqueo.agency.logoUrl} alt="" style={{ maxHeight: 48, maxWidth: 180, objectFit: "contain", marginBottom: "1rem" }} />
        : <div style={{ fontWeight: 800, fontSize: "1.1rem", marginBottom: "1rem" }}>{bloqueo.agency?.name || "Deskte"}</div>}
      <ShieldCheck size={40} color={BRAND} />
      <h2 style={{ margin: "1rem 0 .4rem", color: "#0a1628", textAlign: "center" }}>
        {t("Verifica tu identidad", "Verify your identity")}
      </h2>
      {sinSsn ? (
        <p style={{ color: "#5b7a9a", maxWidth: 360, textAlign: "center", lineHeight: 1.5 }}>
          {t("Para proteger tu información necesitamos verificar tu identidad. Llama a tu agente para revisar tus datos.",
             "To protect your information we need to verify your identity. Please call your agent to review your details.")}
          {contacto}
        </p>
      ) : <>
      <p style={{ color: "#5b7a9a", maxWidth: 360, textAlign: "center", margin: "0 0 1rem", lineHeight: 1.5 }}>
        {t("Para proteger tu información, escribe los últimos 4 números de tu seguro social.",
           "To protect your information, enter the last 4 digits of your Social Security number.")}
      </p>
      {agotado ? (
        <p style={{ color: "#ef4444", maxWidth: 360, textAlign: "center", fontWeight: 600 }}>
          {cerradoDelTodo
            ? t("Por seguridad este enlace quedó cerrado. Pídele a tu agente un enlace nuevo.",
                "For your security this link has been closed. Ask your agent for a new link.")
            : t("Demasiados intentos. Inténtalo mañana o pídele a tu agente un enlace nuevo.",
                "Too many attempts. Try again tomorrow or ask your agent for a new link.")}
          {contacto}
        </p>
      ) : (
        <form onSubmit={enviar} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: ".75rem", width: "100%", maxWidth: 280 }}>
          <input
            value={valor}
            onChange={(e) => setValor(e.target.value.replace(/\D/g, "").slice(0, 4))}
            type="password"
            inputMode="numeric"
            autoComplete="off"
            autoFocus
            placeholder="••••"
            aria-label={t("Últimos 4 del seguro social", "Last 4 of SSN")}
            style={{
              width: "100%", textAlign: "center", fontSize: "1.4rem", letterSpacing: ".5em",
              padding: ".7rem", borderRadius: 12, border: "1px solid #c9d6e3", color: "#0a1628", background: "#fff",
            }}
          />
          {bloqueo.error === "wrong_code" && (
            <div style={{ color: "#ef4444", fontSize: ".85rem", fontWeight: 600, textAlign: "center" }}>
              {t(`No coincide. Te quedan ${bloqueo.attemptsLeft} intentos.`, `That doesn't match. ${bloqueo.attemptsLeft} attempts left.`)}
            </div>
          )}
          <button type="submit" disabled={!listo || verificando} style={{
            width: "100%", padding: ".8rem", borderRadius: 12, border: "none", fontWeight: 800, fontSize: "1rem",
            background: listo ? BRAND : "#c9d6e3", color: "#0a1628", cursor: listo ? "pointer" : "default",
          }}>
            {verificando ? t("Verificando…", "Verifying…") : t("Continuar", "Continue")}
          </button>
        </form>
      )}
      </>}
    </Centered>
  );
}
